<template>
  <q-page class="flex-center">
    <div class="q-pa-md">
      <q-table
        title="Doadores"
        :data="emailRegister.data"
        :columns="columns"
        row-key="id"
        filter="filter"
        :loading="loading"
        :pagination.sync="pagination"
        :selected-rows-label="getSelectedString"
        selection="multiple"
        :selected.sync="selected"
        @request="onRequest"
      >
        <template v-slot:top="props">
          <div class="row col-12 q-col-gutter-xs">
            <div class="col-12 text-center text-h3">Fila de emails</div>
          </div>
          <div class="row col-12">
            <div class="col-10">
              <q-input outlined style="border: 1px solid white;" dense input-class="inputSearch" debounce="300"
                       v-model="filter"
                       placeholder="Buscar">
                <template v-slot:append>
                  <q-icon name="search"/>
                </template>
              </q-input>
            </div>
            <div class="col-1 text-center">
              <q-btn color="bg-purple-10" outline icon="email" @click="sendEmail"></q-btn>
            </div>
            <div class="col-1 text-center">
              <q-btn color="bg-purple-10" outline icon="delete" @click="deleteEmail"></q-btn>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-id="value">
          <q-td>
            <a :href="getLink(value)" target="_blank">
              {{value.row.id}}
            </a>
            <!--<q-btn v-if="value.row.url_ticket_payment" target="_blank" type="a" :href="value.row.url_ticket_payment" round color="primary" icon="backup">-->

          </q-td>
        </template>
      </q-table>
    </div>
  </q-page>
</template>
<script>
import { deleteEmails, EMAIL_REGISTER, InQueueEmail } from '../graphql/graphql'
import { DateTime } from 'luxon'
// 98372349ikjhfn9wf9i8w345nef92020a
export default {
  name: 'EmailSents',
  computed: {
    host () {
      return process.env.VUE_APP_GHOST + '/email-register/'
    }
  },
  methods: {
    getLink (value) {
      return this.host + value.row.id + '?apiKey=98372349ikjhfn9wf9i8w345nef92020a'
    },
    getSelectedString () {
      return this.selected.length === 0 ? '' : `${this.selected.length} linha${this.selected.length > 1 ? 's' : ''} selecionada de ${this.emailRegister.paginatorInfo.total}`
    },
    init () {
      this.loading = true
      this.$apollo.queries.emailRegister.skip = false
      this.$apollo.queries.emailRegister.refetch().then(result => { this.pagination.rowsNumber = result.data.emailRegister.paginatorInfo.total; this.loading = false })
    },
    sendEmail () {
      if (this.selected.length > 0) {
        this.loading = true
        this.$apollo.mutate({
          mutation: InQueueEmail,
          variables: {
            emails: this.selected.map(item => item.id)
          },
          // pollInterval: 300,
          update: (store, data) => {
            this.loading = false
            console.log(store)
            console.log(data)
            alert(data.data.inQueueEmails)
            this.init()
          }
        })
      }
    },
    deleteEmail () {
      let confirm = window.confirm('Deseja mesmo apagar tais mensagens?')
      if (confirm) {
        if (this.selected.length > 0) {
          this.loading = true
          this.$apollo.mutate({
            mutation: deleteEmails,
            variables: {
              emails: this.selected.map(item => item.id)
            },
            // pollInterval: 300,
            update (store, data) {
              alert(data.data.deleteEmails)
              this.loading = false
              this.init()
            }
          })
        }
      }
    },
    onRequest (props) {
      this.loading = true
      this.pagination.page = props.pagination.page
      this.pagination.rowsPerPage = props.pagination.rowsPerPage
      this.donators = this.emailRegister
      this.pagination.rowsNumber = this.emailRegister.paginatorInfo.total
      this.$apollo.addSmartQuery('emailRegister', {
        query: EMAIL_REGISTER,
        variables () {
          return {
            page: this.pagination.page,
            count: this.pagination.rowsPerPage,
            orderBy: [{ field: 'created_at', order: 'DESC' }],
            sent: null
          }
        },
        update () {
          this.loading = false
        }
      })
    }
  },
  data () {
    return {
      loading: true,
      filter: '',
      selected: [],
      columns: [
        {
          name: 'id',

          label: 'ID',
          align: 'left',
          field: 'id'

        }, {
          name: 'donator',

          label: 'Doador',
          align: 'left',
          field: 'donator',
          format: val => val ? `${val.name} ${val.last_name} (${val.email})` : ''

        }, {
          name: 'subject',

          label: 'Assunto',
          align: 'left',
          field: 'subject'

        }, {
          name: 'template',

          label: 'Modelo',
          align: 'left',
          field: 'template',
          format: val => val.name
        }, {
          name: 'created_at',

          label: 'Gerado em',
          align: 'left',
          field: 'created_at',
          format: val => {
            if (val) {
              return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString()
            }
          }

        }, {
          name: 'user',

          label: 'Enviado por',
          align: 'left',
          field: 'user',
          format: user => user.name

        }
      ],
      pagination: {
        sortBy: 'name',
        descending: false,
        page: 1,
        rowsPerPage: 50,
        rowsNumber: 50
      },
      emailRegister: {
        data: [],
        paginatorInfo: {
          total: 0
        }
      }
    }
  },
  apollo: {
    emailRegister: {
      query: EMAIL_REGISTER,
      variables () {
        return {
          page: this.pagination.page,
          count: this.pagination.rowsPerPage,
          orderBy: [{ field: 'created_at', order: 'DESC' }]
        }
      }
      // skip: true
      // pollInterval: 300, // ms
    },
    inQueueEmails: {
      query: EMAIL_REGISTER,
      variables () {
        return {
          emails: this.selected
        }
      },
      skip: true
      // pollInterval: 300, // ms
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style>
  /*.q-linear-progress, .q-table__linear-progress .relative-position,
  .q-linear-progress__track .absolute-full .q-linear-progress__track--light
  {
    height: 50px !important;
  }*/
</style>
